import Text from '../../../components/Text';
import { COLORS, fontSizes } from '../../../constants/constants';
import dynamicfunction from '../../../utils/dynamicfunction';
import Button from '../../../components/Button';
import ImagesSlide from '../../../components/ImagesSlide';
import ViewReverse from '../../../components/ViewReverse';
import { useLocation, useNavigate } from 'react-router';
import { useSelector } from 'react-redux';
import { formatNumbers, getContentKeyAccToLang } from '../../../utils/utils';
import dayjs from 'dayjs';
import SarSymbol from '../../../components/SarSymbol';
import { clientSuspendedToast } from '../../../utils/functions';
import { useEffect } from 'react';

const SubscribeCard = ({ item, isSubscribe = true, straight = false, isFund = false }) => {
  const navigate = useNavigate();
  const { TextWeight, isArabic } = dynamicfunction();
  const pathname = useLocation();

  const { investmentContent } = useSelector((state) => state.content);
  const { user } = useSelector((state) => state.common);

  const isFundsSubscribe = pathname?.pathname === '/funds/subscribe';

  useEffect(() => {
    if (user?.isClientSuspended && (isFundsSubscribe)) {
      clientSuspendedToast(isArabic);
      navigate(-1)
    }
  }, [user?.isClientSuspended])

  const getContentKey = (key) => {
    return getContentKeyAccToLang(investmentContent?.web_investment_fund?.data?.attributes, key, isArabic);
  };

  const images_array = item?.documents?.filter((val) => val?.documentTypeId === 5);

  return (
    <div className='rounded-xl sm:rounded-2xl border border-lavender bg-white p-2.5 sm:p-3 w-full'>
      <ImagesSlide images={images_array} imagesStyle={'h-40 sm:h-48'}
        dotsColor={isFund ? 'bg-yellow' : null}
        arrowColor={isFund ? COLORS.yellow : null} />
      <div className='flex justify-between items-center mt-4 mb-2'>
        <Text text={item?.fundName}
          size={fontSizes.h16} weight={TextWeight.semiBold} isTruncate={true} color='text-black' className={'mt-4 mb-2'} />
        <Text
          text={`${formatNumbers(item?.fundedPercentage)}% ${getContentKey('funded')}`} weight={TextWeight.semiBold}
          color={isFund ? 'text-yellow' : 'text-primary'}
        />
      </div>
      {
        isSubscribe ?
          <div className='h-[48px]'>
            <Text
              className={'line-clamp-2 break-all'}
              text={item?.shortDesc} weight={TextWeight.light} isTruncate={false} />
          </div>
          :
          <div className='mb-3'>
            <Text text={item?.longDesc} weight={TextWeight.light} isTruncate={false} className={'line-clamp-2 break-all'} />
          </div>
      }

      {
        user &&
        <>
          {straight ? (
            <div className='flex justify-between mb-2'>
              <div>
                <Text text={getContentKey('fund_size')} color='text-black' />
                <ViewReverse className={isArabic && 'justify-end'}>
                  <SarSymbol color={isFund ? 'text-yellow' : 'text-primary'} />
                  <Text text={formatNumbers(item?.fundSize)} size={fontSizes.h14} weight={TextWeight.semiBold} color={isFund ? 'text-yellow' : 'text-primary'} />
                </ViewReverse>
              </div>
              <div>
                <Text text={getContentKey('land_area')} color='text-black' />
                <Text
                  text={item?.landArea}
                  size={fontSizes.h14}
                  weight={TextWeight.semiBold}
                  color={isFund ? 'text-yellow' : 'text-primary'}
                />
              </div>
              <div>
                <Text text={getContentKey('duration')} color='text-black' />
                <Text
                  text={item?.duration}
                  size={fontSizes.h14}
                  weight={TextWeight.semiBold}
                  color={isFund ? 'text-yellow' : 'text-primary'}
                  align={isArabic ? 'text-left' : 'text-right'}
                />
              </div>
              <div>
                <Text text={getContentKey('start_date')} color='text-black' />
                <Text
                  text={dayjs(item?.startDate).format('YYYY')}
                  size={fontSizes.h14}
                  weight={TextWeight.semiBold}
                  color={isFund ? 'text-yellow' : 'text-primary'}
                  align={isArabic ? 'text-left' : 'text-right'}
                />
              </div>
            </div>
          ) : (
            <>
              <div className='flex justify-between items-center mb-2'>
                <div>
                  <Text text={getContentKey('fund_size')} color='text-black' />
                  <ViewReverse className={isArabic && 'justify-end'}>
                    <SarSymbol color={isFund ? 'text-yellow' : 'text-primary'} />
                    <Text text={formatNumbers(item?.fundSize)} size={fontSizes.h14} weight={TextWeight.semiBold} color={isFund ? 'text-yellow' : 'text-primary'} />
                  </ViewReverse>
                </div>
                <div>
                  <Text text={getContentKey('duration')} color='text-black' align={isArabic ? 'text-left' : 'text-right'} />
                  <Text
                    text={item?.duration}
                    size={fontSizes.h14}
                    weight={TextWeight.semiBold}
                    color={isFund ? 'text-yellow' : 'text-primary'}
                    align={isArabic ? 'text-left' : 'text-right'}
                  />
                </div>
              </div>
              <div className='flex justify-between items-center mb-2'>
                <div>
                  <Text text={getContentKey('land_area')} color='text-black' />
                  <Text
                    text={item?.landArea}
                    size={fontSizes.h14}
                    weight={TextWeight.semiBold}
                    color={isFund ? 'text-yellow' : 'text-primary'}
                  />
                </div>
                <div>
                  <Text text={getContentKey('start_date')} color='text-black' align={isArabic ? 'text-left' : 'text-right'} />
                  <Text
                    text={dayjs(item?.startDate).format('YYYY')}
                    size={fontSizes.h14}
                    weight={TextWeight.semiBold}
                    color={isFund ? 'text-yellow' : 'text-primary'}
                    align={isArabic ? 'text-left' : 'text-right'}
                  />
                </div>
              </div>
            </>
          )}
        </>
      }

      {isSubscribe && (
        <Button
          text={getContentKey(isFund ? 'view_reports' : 'subscribe')}
          bgColor={isFund ? 'bg-yellow' : 'bg-primary'}
          weight={TextWeight.light}
          // isDisabled={!isFund && user && user?.isClientSuspended}
          className={'w-full rounded-lg capitalize py-2'}
          onClick={() => {
            if (user) {
              if (!isFund && user?.isClientSuspended) {
                clientSuspendedToast(isArabic);
              } else {
                if (isFund) navigate('/funds/my-funds/my-fund-reports', { state: { data: item } });
                else navigate('/funds/subscribe', { state: { item } });
              }
            } else {
              navigate('/login');
            }
          }}
        />
      )}
    </div>
  );
};
export default SubscribeCard;
